import DeviceCheckingStepper from "./components/DeviceCheckingStepper";
import internetSpeed from "../../resources/images/interview-rounds/image-table/internetspeed.svg";
import cameraIconCheck from "../../resources/images/interview-rounds/image-table/camera-icon-check.svg";
import soundCheck from "../../resources/images/invited-candidate/sound-check.svg";
import webBrowserIcon from "../../resources/images/interview-rounds/image-table/web-browser-icon.svg";
// import checkLight from "../../resources/images/invited-candidate/checklight.svg";

const DEVICE_CHECKING_STEPS = [
  {
    id: "camera",
    name: "Camera",
    imgSrc: cameraIconCheck,
  },
  {
    id: "microphone",
    name: "Microphone",
    imgSrc: soundCheck,
  },
  {
    id: "browser",
    name: "Browser",
    imgSrc: webBrowserIcon,
  },
  {
    id: "bandwidth" || "connection",
    name: "Connection",
    imgSrc: internetSpeed,
  },
  // {
  //   name: "Check light",
  //   imgSrc: checkLight
  // }
];

const DeviceChecking = ({ onFinish = () => {} }) => {
  return (
    <DeviceCheckingStepper
      stepsConfig={DEVICE_CHECKING_STEPS}
      onFinish={onFinish}
    />
  );
};

export default DeviceChecking;
